<template>
  <SideMenuBase :menuGroups="menuGroups" />
</template>

<script setup>
import SideMenuBase from '@/components/layout/SideMenuBase.vue'

const menuGroups = [
  {
    title: 'Queue',
    items: [
      { label: 'Rebates', path: '/accounting/rebates'},
    ]
  },
  {
    title: 'Payroll',
    items: [
      { label: 'Generator', path: '/accounting/payroll', requiredPermission: 'accounting.payroll.access'  }
    ]
  },
  {
    title: 'Analytics',
    items: [
      { label: 'Over Under Billing', path: '/accounting/over-under-billing' },
      { label: 'Comm Analysis', path: '/accounting/project-commission-analysis' }
    ]
  }
]
</script>
